import { ComponentInstanceHelpers } from '@diagram/helpers/ComponentInstanceHelpers';
import { useDiagram } from '@diagram/hooks/use-diagram';
import { ComponentInstanceService } from '@diagram/services/ComponentInstanceService';

import { useTipTapMentions } from 'components/tiptap/hooks/use-tiptap-mentions';

const COMPONENT_INSTANCE_MENTION_TYPE = 'mentions-#';

const componentInstanceMentionId = (componentInstanceId: string) => `component-instance:${componentInstanceId}`;

const useComponentInstanceMentions = () => {
    const { componentInstances } = useDiagram();

    return useTipTapMentions({
        key: COMPONENT_INSTANCE_MENTION_TYPE,
        trigger: '#',
        suggestions: Object.values(componentInstances).map((componentInstance) => ({
            id: componentInstanceMentionId(componentInstance.id),
            label: componentInstance.designator,
            group: ComponentInstanceHelpers.definition(componentInstance.componentType).plural,
        })),
        render: ({ node, options }) => {
            const mention = document.createElement('a');

            mention.textContent = `#${node.attrs.label}`;
            mention.addEventListener('click', (event) => {
                event.preventDefault();
                event.stopPropagation();

                const componentInstanceId = node.attrs.id.replace('component-instance:', '');

                ComponentInstanceService.moveIntoView(componentInstanceId, true);
            });

            Object.entries(options.HTMLAttributes).forEach(([key, value]) => {
                mention.setAttribute(key, value);
            });

            return mention;
        },
    });
};

export { COMPONENT_INSTANCE_MENTION_TYPE, componentInstanceMentionId, useComponentInstanceMentions };
